import { render, staticRenderFns } from "./specs.vue?vue&type=template&id=5738a148&scoped=true"
import script from "./specs.vue?vue&type=script&lang=js"
export * from "./specs.vue?vue&type=script&lang=js"
import style0 from "./specs.vue?vue&type=style&index=0&id=5738a148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738a148",
  null
  
)

export default component.exports